/**
 * Chat mode options - Ask / Agent / Auto.
 *
 * Drives both navigation semantics (ask = propose, agent = auto-open, auto = AI
 * decides) and server execution depth (agent = plan-driven runs). Rendered as a
 * card-style ComposerPicker in the composer toolbar.
 */

import type { ChatMode } from '@protoss/shared';
import type { ComposerPickerOption } from './ComposerPicker';

// Agent and Auto are gated 'alpha' - the composer shows them only where the workspace
// featureMinStage is alpha (local/dev); uat/prod (min stage 'beta') see Ask only.
// Mirrors slash-command staging (see isStageAvailable).
export const CHAT_MODE_OPTIONS: ReadonlyArray<ComposerPickerOption<ChatMode>> = [
  { value: 'ask', label: 'Ask', description: 'Answer + propose actions; you decide where to go' },
  {
    value: 'agent',
    label: 'Agent',
    description: 'Plan-driven execution; opens pages automatically',
    stage: 'alpha',
  },
  {
    value: 'auto',
    label: 'Auto',
    description: 'AI decides how deep to go and when to navigate',
    stage: 'alpha',
  },
];
